<template>
  <div>
    <v-row
      class="justify-center">
      <v-col
        id="card-auth-container"
        style="max-width: 916px"
        cols="10"
        md="8">
        <v-card class="container">
          <v-row>
            <v-col md="6" class="background d-none d-md-flex justify-center">
              <img contain src="../../assets/img/logo.svg" width="400px"/>
            </v-col>
            <v-col
              cols="12"
              md="6">
              <v-form
                lazy-validation
                ref="form"
                v-model="valid"
                class="mx-5 my-5">
                  <h3 class="mb-3">{{$t('general.login')}}</h3>
                 <v-text-field
                  outlined
                  dense
                  class="mb-2"
                  :label="$t('general.email')"
                  :rules="rules.email"
                  @keyup.enter="login"
                  v-model="email"
                ></v-text-field>
                <v-text-field
                  outlined
                  dense
                  v-model="password"
                  :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                  :rules="rules.required"
                  :type="show ? 'text' : 'password'"
                  :label="$t('login.password')"
                  @keyup.enter="login"
                  @click:append="show = !show"
                  :error-messages="errors.password ? errors.password[0]: ''"
                ></v-text-field>
                <v-row>
                  <v-col>
                    <router-link
                      to="/auth/recover">{{$t('login.forgot')}}</router-link>
                    <v-btn
                      color="primary"
                      class="float-right"
                      :loading="loading"
                      :disabled="loading"
                      @click="login">
                      {{$t('general.enter')}}
                    </v-btn>
                  </v-col>
                </v-row>
                <!-- <v-row>
                  <v-col cols="12" class="text-center">
                    <span class="text-center">{{$t('login.noAccount')}}</span><br>
                    <span class="text-center">
                      <router-link
                      to="/auth/registration">
                      {{$t('login.signUp')}}
                      </router-link>
                    </span>
                  </v-col>
                </v-row> -->
              </v-form>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  data () {
    return {
      errors: {},
      password: '',
      email: '',
      valid: true,
      show: false,
      loading: false
    }
  },
  props: ['lang'],
  computed: {
    rules () {
      return this.$validationRules()
    }
  },
  methods: {
    login () {
      if (this.$refs.form.validate()) {
        this.loading = true
        this.errors = {}
        this.$store.dispatch('login', {
          event: {
            context: this,
            password: this.password,
            email: this.email
          }
        })
      }
    }
  }
}
</script>

<style scoped>
  .background {
    background-color: #F7F7F7;
  }
  .v-card {
    padding: 0;
    display: flex;
    align-items: center;
  }
  a {
    text-decoration: none;
  }
</style>